import { Form, Select, Button, Row, Col } from "antd";
import find from "lodash/find";
import map from "lodash/map";
import get from "lodash/get";
import { getButtonDisabled } from "../../utilities/helpers";

const HeaderSelector = ({ filter, config, setFilters, setConfig, setTemplateType }) => {
  return (
    <div className="w-full px-8 py-6">
      <div className="flex items-start md:items-center w-full flex-wrap h-full gap-2 md:gap-0 md:space-x-5">
        <Row className="gap-0 md:gap-4 xl:gap-0 w-full" gutter={18}>
          <Col xs={24} md={6}>
            <Form.Item
              name="Company"
              label="Company"
              colon={false}
              layout="vertical"
            >
              <Select
                style={{ minWidth: 250 }}
                size="middle"
                optionFilterProp="label"
                showSearch
                value={get(filter, "company")}
                placeholder="Select Company"
                options={map(get(config, "companies"), (company) => ({
                  label: get(company, "name"),
                  value: get(company, "id"),
                }))}
                onChange={(val) => {
                  const company = find(get(config, "companies"), ["id", val]);
                  setFilters({
                    ...filter,
                    company,
                  });
                  setTemplateType(undefined)
                  setConfig({
                    ...config,
                    parts: [],
                    template_types: get(company, "template_access_list"),
                  });
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={6}>
            <Form.Item name="submit" label=" " colon={false} layout="vertical">
              <Button
                type="primary"
                className="w-30"
                htmlType="submit"
                disabled={getButtonDisabled(filter, ["company"])}
                onClick={() => {
                  setTemplateType(undefined)
                }}
              >
                Submit
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default HeaderSelector;
